module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAARVBMVEUAAAB/f39/f3+SkpKSkpKenp6WlpaWlpaampqampqWlpaYmJiXl5eWlpaXl5eWlpaYmJiXl5eXl5eXl5eYmJiYmJiXl5dED0VPAAAAFnRSTlMABAYHDh0zPz9OZnmFmZvIyOHp7Pf+UELfRQAAAJRJREFUKM/dkksOwyAMRIcCgZhfCTT3P2oXURAQS6xbryw92R6PDfxDCEOOjOCh8iUFH1LxiqFbjhoAoGPenvTYW74fM1f5oufF89TfR3QY0Y+aix6wLoN+mzBgJNtjChMO1GN3zzqllC8A3rHVn1rr+1HdZt+RDKscrPK2N9i9m2vgXVt4vrrY6t4AhCVHVvzIb38BLOgFupHMi24AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order_detail/icon_order_detail_time.png
// module id = Py3E
// module chunks = 0